module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-function.f6a89708.png";